'use strict';
import React from 'react';
import Portal from 'react-portal';
import flux from 'utils/flux';
import LoginSlideshow from './loginSlideshow';
import LoginBackgroundVideo from './loginBackgroundVideo';
import AltContainer from 'alt-container';

var LoginPage = React.createClass({
    displayName: 'LoginPage',
    mixins: [],
    propTypes: {},
    statics: {
        willTransitionTo: function(transition) {
            if (flux.getStore('app').isAuthenticated()) {
                transition.redirect('/');
            }
        }
    },

    showLogin(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('Login');
    },

    getTitle(html) {
        return { __html: html };
    },

    showRegister(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('Register');
    },
    componentDidMount() {
        if (
            this.props.query.showDialog ||
            ( this.props.query.nextPath && this.props.query.nextPath.length > 1 )
        ) {
            setTimeout(() => {
                flux.getActions('modals').openModal('Login');
            }, 10);
        }
    },
    renderFullbleed() {
        var isMobile = ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) );
        var backGroundLayer;

        if (!isMobile) {
            if( window.config.backgroundMovie.length>1 && window.config.backgroundMovie.indexOf("-")>1) {
                backGroundLayer = (
                    <LoginBackgroundVideo
                        poster={window.config.slideshowImages[0]}
                        video={window.config.backgroundMovie}
                    />
                );
            } else {
                backGroundLayer = (
                    <LoginSlideshow
                        show={window.config.slideshowImages}
                        speed={4000}
                    />
                );
            }

        } else {
            backGroundLayer = (
                <LoginSlideshow
                    show={window.config.slideshowImages}
                    speed={4000}
                />
            );
        }

        return backGroundLayer;
    },
    _renderLoginText(modalIsOpen) {
        const {licensing} = flux.getStore('app').getState().config.toJS();
        if (!modalIsOpen) {
            return (
                <div>
                    <h1 dangerouslySetInnerHTML={this.getTitle(flux.t('login_video_pretitle'))}/>
                    <h2 dangerouslySetInnerHTML={this.getTitle(flux.t('login_video_title'))}/>
                    <a href="#" className="btn btn-primary btn-arrow" onClick={this.showRegister}>
                        {flux.t('sign_up')}
                        <i className="gopro-chevron-right" />
                    </a>

                    {(!licensing) ?
                        <a href="#" className="btn btn-secondary btn-arrow" onClick={this.showLogin}>
                            {flux.t('login')}
                            <i className="gopro-chevron-right" />
                        </a>
                    : ''
                    }
                </div>
            );
        }
    },
    render() {
        return (
            <AltContainer
                stores={{modalStore: this.props.flux.getStore('modals')}}
                render={(props) => {
                    return (
                        <div className="welcome container--centered">
                            {this._renderLoginText(props.modalStore.openModal)}
                            <Portal isOpened={true}>
                               {this.renderFullbleed()}
                            </Portal>
                        </div>);
                }} />
        );
    }
});

module.exports = LoginPage;



// WEBPACK FOOTER //
// ./app/pages/login/loginIndex.jsx